module.exports = __webpack_public_path__ + "static/media/campus-food-truck-catering-3.3ecc2781.jpg";